import { createReducer, on } from '@ngrx/store';

import { RestAuditModel } from '@shared/interfaces/audit.interface';
import { RestRenewalModel, RestUnitRenewalTargetModel } from '@shared/interfaces/renevals.interface';

import {
  getRenewalChangesHistory,
  getRenewalChangesHistoryFailure,
  getRenewalChangesHistorySuccess,
  loadRenewalDetails,
  loadRenewalDetailsFailure,
  loadRenewalDetailsSucceded,
  loadRenewalStrategyForUnit,
  loadRenewalStrategyForUnitFailed,
  loadRenewalStrategyForUnitSucceded,
  loadRenewalsList,
  loadRenewalsListFailure,
  loadRenewalsListSucceded,
} from './renewals.actions';

export const renewalsFeatureKey = 'renewals';

export interface RenewalsState {
  renewalsList: RestRenewalModel[];
  renewalsListLoading: boolean;

  renewalDetailsLoading: boolean;
  renewalDetails: RestRenewalModel;

  renewalStrategyForUnit: RestUnitRenewalTargetModel;
  renewalStrategyForUnitLoading: boolean;
  auditModelList?: RestAuditModel[];
  auditModelListLoading?: boolean;
}

export const initialState: RenewalsState = {
  renewalsList: [],
  renewalsListLoading: false,

  renewalDetailsLoading: false,
  renewalDetails: null,

  renewalStrategyForUnit: null,
  renewalStrategyForUnitLoading: false,

  auditModelList: [],
  auditModelListLoading: false,
};

export const reducer = createReducer(
  initialState,

  /* Renewals List */
  on(loadRenewalsList, (state, action) => ({ ...state, renewalsListLoading: true })),
  on(loadRenewalsListSucceded, (state, action) => ({
    ...state,
    renewalsListLoading: false,
    renewalsList: action.renewalsList,
  })),
  on(loadRenewalsListFailure, (state, action) => ({ ...state, renewalsListLoading: false, renewalsList: [] })),

  /* Renewal Details */
  on(loadRenewalDetails, (state, action) => ({ ...state, renewalDetailsLoading: true })),
  on(loadRenewalDetailsSucceded, (state, action) => ({
    ...state,
    renewalDetails: action.renewalDetails,
    renewalDetailsLoading: false,
  })),
  on(loadRenewalDetailsFailure, (state, action) => ({ ...state, renewalDetails: null, renewalDetailsLoading: false })),

  /* Renewal Strategy For Unit */
  on(loadRenewalStrategyForUnit, (state, action) => ({ ...state, renewalStrategyForUnitLoading: true })),
  on(loadRenewalStrategyForUnitSucceded, (state, action) => ({
    ...state,
    renewalStrategyForUnit: action.unitTypeRentTarget,
    renewalStrategyForUnitLoading: false,
  })),
  on(loadRenewalStrategyForUnitFailed, (state, action) => ({
    ...state,
    renewalStrategyForUnit: null,
    renewalStrategyForUnitLoading: false,
  })),

  /* get changes history */
  on(getRenewalChangesHistory, (state, action) => ({ ...state, auditModelListLoading: true })),
  on(getRenewalChangesHistorySuccess, (state, action) => ({
    ...state,
    auditModelList: action.auditModelList,
    auditModelListLoading: false,
  })),
  on(getRenewalChangesHistoryFailure, (state, action) => ({
    ...state,
    auditModelList: [],
    auditModelListLoading: false,
  }))
);
